import {
  Box,
  Checkbox,
  IconHelp,
  Inline,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import type { ReactNode } from 'react';

type LabelContent = NonNullable<ReactNode>;

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: LabelContent;
  tooltip: LabelContent;
}

export const Toggle = ({ checked, onChange, label, tooltip }: Props) => (
  <Inline space="xxsmall" alignY="center">
    <Checkbox
      checked={checked}
      onChange={(event) => onChange(event.currentTarget.checked)}
      label={label}
      size="small"
    />
    <TooltipRenderer tooltip={<Text>{tooltip}</Text>}>
      {({ triggerProps }) => (
        <Box aria-label="Help" {...triggerProps}>
          <IconHelp />
        </Box>
      )}
    </TooltipRenderer>
  </Inline>
);
